import base from './base.repository';
export default {
    ...base,
    getAnnotationTypes(){
        this.get('vigilance/data/annotation-types');
        return this;
    },
    saveNote(payload){
        this.post('vigilance/notebook/save-note', payload);
        return this;
    },
    getTransitories(clientId){
        this.get(`vigilance/notebook/client/${clientId}/transitories`);
        return this;
    },
    getNotes(clientId, page, filters){
        const params = {...filters, page: page};
        this.get(`vigilance/notebook/client/${clientId}/notes${this.querify(params)}`);
        return this;
    },
    deleteNote(noteId){
        this.delete(`vigilance/notebook/client/${noteId}/delete`);
        return this;
    },
    finalize(noteId){
        this.post('vigilance/notebook/finalize-transitory', {noteId});
        return this;
    },
    getAuthorsAnnotations(clientId){
        this.get(`vigilance/notebook/client/${clientId}/authors-annotations`);
        return this;
    },
    getNotesByClient(clientId, page, filters){
        const params = {...filters, page: page};
        this.get(`vigilance/notebook/client/${clientId}/notes${this.querify(params)}`);
        return this;
    },
    getNotesBySupervisors(filters, page){
        const params = {...filters, page: page};
        this.get(`vigilance/notebook/created-by-supervisors${this.querify(params)}`);
        return this;
    },
    getAuthorsSupervisors(){
        this.get(`vigilance/notebook/authors-supervisors`);
        return this;
    },
    
}